export type SkeletonProps = {
  width?: number | string
  height?: number | string
  radius?: string
}

/** Loading placeholder. Decorative, so it is hidden from the screen reader. */
export function Skeleton({ width = '100%', height = 16, radius }: SkeletonProps) {
  return (
    <div className="skeleton" aria-hidden="true" style={{ width, height, borderRadius: radius }} />
  )
}
